import { MainInner } from "@/styles/global";
import { Paragraph, h2, h4 } from "@/styles/typography";
import styled from "styled-components";

const Inner = styled(MainInner)`
  gap: 24px;

  @media (min-width: ${({ theme }) => theme.breakpoints.lg}) {
    gap: 48px;
  }
`;

const Title = styled(h2)``;

const CardsWrapper = styled.div`
  gap: 16px;
  display: grid;

  @media (min-width: ${({ theme }) => theme.breakpoints.sm}) {
    grid-template-columns: repeat(auto-fill, minmax(286px, 1fr));
  }

  @media (min-width: ${({ theme }) => theme.breakpoints.lg}) {
    gap: 24px;
  }
`;

const Card = styled.div`
  min-width: 286px;
  display: flex;
  flex-direction: column;
  gap: 16px;
  padding: 16px;
  background-color: ${({ theme }) => theme.colors.coreMedium};
  border-radius: 4px;

  @media (min-width: ${({ theme }) => theme.breakpoints.lg}) {
    padding: 24px;
  }
`;

const CardTitle = styled(h4)``;

const Text = styled(Paragraph)``;

const S = {
  Inner,
  Title,
  CardsWrapper,
  Card,
  CardTitle,
  Text,
};

export default S;
